export default "__VITE_ASSET__BWh5$joe__"